import * as React from "react";
import Graphism from "./representment-graphism.png";

const RepresentmentGraphism = () => (
  <img alt="grafismo da pagar.me" src={Graphism} />
);

export default RepresentmentGraphism;
